import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  numberAttribute,
  output,
} from '@angular/core';
import { UiButtonComponent } from '../../atoms/button/button.component';
import { UiTagComponent } from '../../atoms/tag/tag.component';

/** Aviso del panel de notificaciones. Solo presentación. */
export interface UiNotificationMenuItem {
  id: string;
  title: string;
  datetime: string;
  message: string;
  /** Línea extra, por ejemplo el documento. */
  context?: string;
  /** Desarrollo. Si viene definido, se muestra el nombre. */
  project?: string;
  /** Si viene definido, aunque sea vacío, se muestra «Modelo:». */
  model?: string;
  /** Si viene definido, aunque sea vacío, se muestra «Unidad:». */
  unit?: string;
  /** Destino que interpreta la app. La molécula no navega. */
  href?: string;
  /** `true` muestra «Leída». Sin valor o `false`, «No leída». */
  read?: boolean;
}

/**
 * Molécula: panel de notificaciones.
 * Muestra un máximo de avisos y la acción «Ver todas».
 * No navega: emite el aviso o la acción final para que la app decida.
 */
@Component({
  selector: 'ui-notification-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiButtonComponent, UiTagComponent],
  templateUrl: './notification-menu.component.html',
  styleUrl: './notification-menu.component.scss',
  host: {
    class: 'ui-notification-menu-host',
    role: 'dialog',
    'aria-label': 'Notificaciones',
  },
})
export class UiNotificationMenuComponent {
  readonly items = input<readonly UiNotificationMenuItem[]>([]);
  readonly visibleCount = input(3, { transform: numberAttribute });
  readonly viewAllLabel = input('Ver todas');

  readonly itemSelect = output<UiNotificationMenuItem>();
  readonly viewAll = output<void>();

  protected readonly visibleItems = computed(() =>
    this.items().slice(0, Math.max(0, this.visibleCount())),
  );

  protected showsProperty(item: UiNotificationMenuItem): boolean {
    return item.model !== undefined || item.unit !== undefined;
  }

  protected onItem(item: UiNotificationMenuItem): void {
    this.itemSelect.emit(item);
  }

  protected onViewAll(): void {
    this.viewAll.emit();
  }
}
